export const wafCaptchaManager = {
    state: {
        needCaptcha: false,
        pendingRequests: [],
        listeners: [],
        targetPath: '',
        showRateLimit: false,
        rateLimitListeners: [],
        rateLimitMessage: '',
        needRestricted: false,
        restrictedListeners: [],
        restrictedResolvedListeners: []
    },

    setNeedCaptcha(needCaptcha) {
        this.state.needCaptcha = needCaptcha;
        this.notifyListeners();
    },

    isNeedCaptcha() {
        return this.state.needCaptcha;
    },

    setShowRateLimit(show, message = '') {
        this.state.showRateLimit = show;
        this.state.rateLimitMessage = message;
        this.notifyRateLimitListeners();
    },

    isShowRateLimit() {
        return this.state.showRateLimit;
    },

    getRateLimitMessage() {
        return this.state.rateLimitMessage;
    },

    setTargetPath(path) {
        this.state.targetPath = path;
    },

    getTargetPath() {
        return this.state.targetPath;
    },

    addPendingRequest(requestConfig) {
        this.state.pendingRequests.push(requestConfig);
    },

    getPendingRequests() {
        return this.state.pendingRequests;
    },

    clearPendingRequests() {
        this.state.pendingRequests = [];
    },

    onCaptchaVerified(callback) {
        if (typeof callback === 'function') {
            this.state.listeners.push(callback);
        }
    },

    notifyListeners() {
        this.state.listeners.forEach(listener => {
            try {
                listener(this.state.needCaptcha);
            } catch (error) {
                console.error('Error in wafCaptchaManager listener:', error);
            }
        });
    },

    clearListeners() {
        this.state.listeners = [];
    },

    onRateLimitChange(callback) {
        if (typeof callback === 'function') {
            this.state.rateLimitListeners.push(callback);
        }
    },

    notifyRateLimitListeners() {
        this.state.rateLimitListeners.forEach(listener => {
            try {
                listener(this.state.showRateLimit, this.state.rateLimitMessage);
            } catch (error) {
                console.error('Error in rateLimitListeners:', error);
            }
        });
    },

    setNeedRestricted(needRestricted) {
        this.state.needRestricted = needRestricted;
        this.notifyRestrictedListeners();
    },

    isNeedRestricted() {
        return this.state.needRestricted;
    },

    onRestrictedChange(callback) {
        if (typeof callback === 'function') {
            this.state.restrictedListeners.push(callback);
        }
    },

    notifyRestrictedListeners() {
        this.state.restrictedListeners.forEach(listener => {
            try {
                listener(this.state.needRestricted);
            } catch (error) {
                console.error('Error in restrictedListeners:', error);
            }
        });
    },

    onRestrictedResolved(callback) {
        if (typeof callback === 'function') {
            this.state.restrictedResolvedListeners.push(callback);
        }
    },

    offRestrictedResolved(callback) {
        this.state.restrictedResolvedListeners = this.state.restrictedResolvedListeners.filter(
            (fn) => fn !== callback
        );
    },

    notifyRestrictedResolved() {
        this.state.restrictedResolvedListeners.forEach(listener => {
            try {
                listener();
            } catch (error) {
                console.error('Error in restrictedResolvedListeners:', error);
            }
        });
    }
};
